import axios from 'axios'

import { FORGE_BASE, getForgeToken } from './config'

// standalone axios instance, not middlewareController — forge's own 401s shouldn't trigger container's logout flow
export const forgeApi = axios.create({ baseURL: FORGE_BASE })

forgeApi.interceptors.request.use(config => {
  // reads localStorage on every request — tokens stay fresh without a re-login,
  // but a stale token sent in-flight will 401 and surface as a normal API error
  config.headers.set('x-api-key', getForgeToken())
  return config
})

export * from './config'
export * from './forgeApi.types'
export * from './requests'
